const DEFAULT_DISPLAY_STATUSES = ['pending', 'draft', 'accepted', 'review'];

export const buildDisplayedBookingInvites = (garageInvites = [], expandedInvites) => {
  const invitesWithCandidateNumbers = [...garageInvites]
    .sort((a, b) => Date.parse(a.creationDateTime) - Date.parse(b.creationDateTime))
    .map((invitation, index) => ({ ...invitation, candidateNumber: index + 1 }));

  const visibleInvites = invitesWithCandidateNumbers.filter(
    ({ status }) => expandedInvites || DEFAULT_DISPLAY_STATUSES.includes(status)
  );

  return visibleInvites.length > 0 || expandedInvites ? visibleInvites : invitesWithCandidateNumbers;
};
